import { createFileRoute } from "@tanstack/react-router";
import backgroundImage from "@/assets/booking-bg.svg";
export const Route = createFileRoute("/bookings")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <div className="fixed inset-0 -z-10">
        <img
          src={backgroundImage}
          alt="Background"
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>
      <div className="z-100 ml-8 mt-14 flex flex-col justify-between h-[25%] w-[96%] items-start bg-white">
        <div className="pl-8 pt-8">
          <span className="text-5xl/14">
            Booking at <br />
            DAILY AFFAIR
          </span>
        </div>
        <div className="pr-6 pt-10 pb-10 self-end">
          <span className="text-2xl/8">
            For booking & function pack instance, <br />
            kindly Whatsapp to +62847194374
          </span>
        </div>
      </div>
    </>
  );
}
